import SLSParametrosClient from '@/api/SistemaDKP/sls-parametros.client';

export default class SLSParametrosService {
  constructor() {
    this.client = new SLSParametrosClient();
  }

  async index(queries = {}) {
    const { data } = await this.client.findAll(queries);
    return data;
  }

  async store(data) {
    return this.client.create(data);
  }

  async update(id, data) {
    return this.client.update(id, data);
  }

  async destroy(id) {
    return this.client.delete(id);
  }

  async findByDescricao(descricao, exact = false) {
    try {
      return await this.client.findByDescricao(descricao, exact);
    } catch (_) {
      return null;
    }
  }
}
